module.exports = __webpack_public_path__ + "img/wienerin.d386b933.svg";